/* Реестр модулей, переписанных на React. Ключ — имя файла прототипа без расширения (как в src/legacy/replaced.json).
   Установщик вызывается в том месте порядка app.html, где стоял старый скрипт: SteosUI, BotCore и модули до него уже есть в window. */
import { installApp } from '../features/app/module';
import { installAvatar } from '../features/avatar/module';
import { installBalance } from '../features/balance/module';
import { installClone } from '../features/clone/module';
import { installCollage } from '../features/collage/module';
import { installCover } from '../features/cover/module';
import { installDance } from '../features/dance/module';
import { installHelp } from '../features/help/module';
import { installHistory } from '../features/history/module';
import { installInfog } from '../features/infog/module';
import { installMarket } from '../features/market/module';
import { installMcard } from '../features/mcard/module';
import { installPartner } from '../features/partner/module';
import { installPhoto } from '../features/photo/module';
import { installPost } from '../features/post/module';
import { installProfile } from '../features/profile/module';
import { installPshoot } from '../features/pshoot/module';
import { installReels } from '../features/reels/module';
import { installRewards } from '../features/rewards/module';
import { installScript } from '../features/script/module';
import { installSettings } from '../features/settings/module';
import { installShell } from '../features/shell/module';
import { installShoot } from '../features/shoot/module';
import { installStudio } from '../features/studio/module';
import { installText } from '../features/text/module';
import { installVoice } from '../features/voice/module';

const INSTALL: Record<string, () => void> = {
  'bot-rewards': installRewards,
  'bot-clone': installClone,
  'bot-studio': installStudio,
  'bot-app': installApp,
  'bot-photo': installPhoto,
  'bot-shoot': installShoot,
  'bot-text': installText,
  'bot-reels': installReels,
  'bot-voice': installVoice,
  'bot-script': installScript,
  'bot-cover': installCover,
  'bot-avatar': installAvatar,
  'bot-market': installMarket,
  'bot-pshoot': installPshoot,
  'bot-infog': installInfog,
  'bot-post': installPost,
  'bot-collage': installCollage,
  'bot-dance': installDance,
  'bot-mcard': installMcard,
  'bot-history': installHistory,
  'bot-profile': installProfile,
  'bot-settings': installSettings,
  'bot-help': installHelp,
  'bot-partner': installPartner,
  'bot-balance': installBalance,
  shell: installShell,
};

export function installModule(name: string): void {
  const fn = INSTALL[name];
  if (!fn) throw new Error(`модуль ${name} помечен заменённым, но React-установщика нет`);
  fn();
}
